import type {
    ComposableOptionsBase,
    Claim,
    UpdateApiDataParams,
    SiteMembershipContext
} from '~/types';
import { ClaimModel } from '~/models';
import {
    useCustomFetch
} from '~/composables';
import { useApiUtils } from 'x1-base/composables';
import type { NitroFetchOptions } from 'nitropack';
import type { NuxtError } from '#app';

export interface UseClaimsOptions extends ComposableOptionsBase {
    siteMembershipContext?: SiteMembershipContext;
}
export function useClaims(options: Partial<UseClaimsOptions> = {}) {
    const apiBasePath = `/v1/claims`;
    const apiBaseClaimsFilePath = `/v1/claim-files`;
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();
    const genericCrudMethods = useGenericCrudMethods<Claim>(
        apiBasePath,
        ClaimModel,
        {
            itemsQueryParams: { expand : 'sku,claim-files' }
        }
    );

    async function updateItem(args: UpdateApiDataParams<Claim>): Promise<ClaimModel | Error> {
        let url = `${apiBasePath}/${args.uid}/`;

        if (args.params?.submit) {
            url = `${url}submit/`;
        }

        const config: NitroFetchOptions<string> = {
            method: 'PATCH',
            body: args.data
        };

        try {
            const response = await $_fetch<Claim>(url, config);
            return ClaimModel.toPlainObject<ClaimModel>(response);
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    async function deleteFile(fileUid: string): Promise<any | NuxtError> {
        const url = `${apiBaseClaimsFilePath}/${fileUid}/`;
        const config: NitroFetchOptions<string> = {
            method: 'DELETE'
        };

        try {
            return await $_fetch<any>(url, config);
        } catch (err) {
            return useApiUtilsObj.getNuxtErrorObj(err);
        }
    }

    return {
        ...genericCrudMethods,
        updateItem,
        deleteFile
    };
}
